/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";

import { Container, Content } from "./styles";
import { LOCAL_STORE_THEME_IMAGE } from "../../constants";
import { getItemLocalStore } from "utils/storeUtils";
import themes from "../../themes";
import assets from "../../assets";

type CardClientProps = {
  number: string;
  userName: string;
  urlTema: string;
  cardTheme?: string;
};

const CardClient = ({
  number,
  userName,
  urlTema,
  cardTheme,
}: CardClientProps) => {
  const [urlImagem, setUrlImagem] = useState(
    getItemLocalStore(LOCAL_STORE_THEME_IMAGE)
  );

  useEffect(() => {
    let url = getItemLocalStore(LOCAL_STORE_THEME_IMAGE);
    if (url) {
      setUrlImagem(url);
    }
  }, []);

  return (
    <Container style={{ opacity: number ? 1 : 0.6 }}>
      <img
        alt="teucard"
        src={urlTema ?? urlImagem ?? assets.images.cardBackgroundTeuCard}
      />

      <Content
        temaCardFont={
          ["PLATINUM", "LUDICO", "CONVENIO"].includes(cardTheme ?? "") &&
          themes.components.colors.font
        }
      >
        <h6>{number || "●●●● ●●●● ●●●● ●●●●"}</h6>
        {userName && <p>{userName}</p>}
      </Content>
    </Container>
  );
};

export default CardClient;
